<template>
  <img
    :src="companyImage"
    class="img-fluid w-100 m-auto"
  >
</template>

<script>
export default {
  props: {
    url: { type: String },
  },
  computed: {
    companyImage() {
      if (this.url.includes('gravatar')) {
        return '/img/icons/no-company.png';
      }
      return this.url;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-width: 80%;
  padding-bottom: 0.75rem;
}
</style>
